<template>
  <div class="custom-alert">
    <span class="close-button" @click="closeAlert">x</span>
    <p>{{ content }}</p>
  </div>
</template>

<script>
export default {
  name: "CustomAlert",
  props: {
    type: String,
    content: String
  },
  methods: {
    closeAlert: function() {
      this.$el.style.display = "none";
    }
  },
  mounted: function() {
    if (this.type === "error") this.$el.style.color = "#b94747";
    else if (this.type === "warning") this.$el.style.color = "#b76718";
    else if (this.type === "success") this.$el.style.color = "#47acb9";
    else this.$el.style.color = "gray";
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.custom-alert {
  background-color: #ffffff;
  color: #47a3b9;
  padding: 20px;
  margin: 10px;
  box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.4);
  border-radius: 10px;
  width: 250px;
  z-index: 1;
}

.close-button {
  cursor: pointer;
  font-size: 1.5em;
  font-weight: bold;
  float: right;
  margin-left: 15px;

  &:hover {
    color: #47a3b9;
  }
}
</style>
